/**
 * Card-linked Miles (Fidel) launch flag, browser side. Off until launch:
 * Profile and Rewards look exactly as before. Turn on with
 * VITE_CARD_LINKED_MILES_ENABLED=true together with the server's
 * CARD_LINKED_MILES_ENABLED=true (server/fidel-rewards.js), and only once the
 * Terms notice Fidel requires, the Privacy Policy lines and the concierge's
 * knowledge base are live. Vite inlines the value, so flipping it rebuilds.
 */
function readFlag() {
  try {
    return import.meta.env.VITE_CARD_LINKED_MILES_ENABLED === 'true';
  } catch {
    return false;
  }
}

export const CARD_LINKED_MILES_ENABLED = readFlag();
